import React from "react";
import { EuiTab, EuiTabs, EuiNotificationBadge } from "@elastic/eui";
import { createUseStyles } from "react-jss";
import { COLORS } from "Consts";

const useTabStyles = createUseStyles({
  tab: {
    "& .euiTab__content": {
      color: COLORS.$euiColorMediumShade + "!important",
    },
    "&.euiTab-isSelected .euiTab__content": {
      color: "var(--button-bg) !important;",
    },
    cursor: "pointer",
  },
});

export interface TabItem {
  id: string | number;
  name: string;
}

export interface TabsProps {
  items: TabItem[];
  onClick: (id: string | number) => void;
  selectedTabId?: string | number;
  className?: string;
  tabClassName?: string;
  bottomBorder?: boolean;
}

const Tabs: React.FC<TabsProps> = ({
  items = [],
  onClick,
  selectedTabId,
  className,
  bottomBorder = true,
}) => {
  const classes = useTabStyles();
  const hasItems = items.length > 0;

  const renderTabs = () => {
    if (!hasItems) {
      return (
        <EuiTab
          color="text"
          key="placeholdertab"
          onClick={() => {}}
          style={{ visibility: "hidden", cursor: "pointer" }}>
          placeholdertab
        </EuiTab>
      );
    }

    return items.map((item: any, index: number) => {
      const isSelected = item.id === selectedTabId;

      return (
        <EuiTab
          color="text"
          className={classes.tab}
          isSelected={isSelected}
          css={isSelected ? { boxShadow: "inset 0 -2px 0 var(--button-bg)" } : {}}
          key={`${item.name}_${index}`}
          onClick={() => onClick(item.id)}>
          {item.name}

          {item?.badgeCount && (
            <span style={{ marginLeft: "8px" }} key={`badge_${index}`}>
              <EuiNotificationBadge>{item?.badgeCount}</EuiNotificationBadge>
            </span>
          )}
        </EuiTab>
      );
    });
  };

  return (
    <EuiTabs
      bottomBorder={bottomBorder}
      className={className}
      style={
        bottomBorder
          ? {
              borderBottom: "1px solid var(--border-color)",
            }
          : {}
      }>
      {renderTabs()}
    </EuiTabs>
  );
};

export default Tabs;
